import { useRef } from "react";
import { toastAlert } from "../../utils/AlertContext";
import { addImgURL, editImgURL } from "../../utils/ConstantsURL";

export const useImageHandler = (date, token, refresh, selectedNote, filteredData) => { 
  const inputFileRef = useRef(null);

  const handleAddOrUpdateImage = async (selectedImage) => {
    const formData = new FormData();
    formData.append("fecha", date);
    formData.append("imagen", selectedImage);
    formData.append("id_sintesis", selectedNote.id_sintesis);
    formData.append("cvcapsula", selectedNote.cvcapsula);

    const isUpdating = filteredData.some(
      (item) =>
        item.id_sintesis === selectedNote.id_sintesis && item.imagen !== null
    );

    try {
      const response = await fetch(isUpdating ? editImgURL() : addImgURL(), {
        method: isUpdating ? "PUT" : "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      if (response.ok) {
        refresh();
        toastAlert(
          isUpdating ? "Imagen actualizada" : "Imagen añadida",
          "success"
        );
      }
    } catch (error) {
      toastAlert(
        isUpdating
          ? "Error al actualizar la imagen"
          : "Error al añadir la imagen",
        "error"
      );
    }
  };

  const handleFileChange = (event) => {
    const selectedImage = event.target.files[0];
    if (selectedImage) {
      handleAddOrUpdateImage(selectedImage);
    }
  };

  const triggerFileInput = () => {
    inputFileRef.current.click();
  };

  return {
    inputFileRef,
    handleFileChange,
    triggerFileInput,
  };
};